import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import BlockLink from './BlockLink';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import swiper from 'swiper';
/* ===============================================
Check responsive state
=============================================== */
window.onload = function() {
	let imgs =document.getElementsByTagName("img");
	let imgNum = document.getElementsByTagName("img").length;
	for(let i=0;i<imgNum;i++){
		imgs[i].oncontextmenu = function(){
			return false;
		}
		imgs[i].onmousedown = function(){
			return false;
		}
	}
}

const r = new Responsive();

$(window).on('load',function(){
	if(bowser.msie === true) {
		$('body').addClass('ie');
	}else if(bowser.msedge === true){
		$('body').addClass('edge');
	}else if(bowser.firefox === true){
		$('body').addClass('ff');
	}

	if(bowser.mobile === true){
		$('body').addClass('device--mobile');
		$(document).ready(function(){
			window.addEventListener("orientationchange", function(){
				location.reload();
			});
		});

		if(bowser.android === true) {
			$('body').addClass('device--mobile--android');
		}
	}

	if(bowser.android === true) {
		$('body').addClass('android');
	}

	let os, ua = navigator.userAgent;
	if (ua.match(/Win(dows )?NT 10\.0/)) {
		os = "win10 win";
	}
	else if (ua.match(/Win(dows )?NT 6\.3/)) {
		os = "win8_1 win";
	}
	else if (ua.match(/Win(dows )?NT 6\.2/)) {
		os = "win8 win";
	}
	else if (ua.match(/Win(dows )?NT 6\.1/)) {
		os = "win7 win";
	}else{
		os = '';
	}

	$('body').addClass(os);
});

/* ===============================================
SP Navi
=============================================== */
const gnavi_clone = $('.gnavi').clone();
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
$('#spnavi #scroller .inner').prepend(gnavi_clone);
$('#spnavi .gnavi > ul > li').each(function(){
	if($(this).find('ul').length > 0){
		$(this).addClass('hasChild');
		$(this).find('a').after('<span />');
	}
});

const spnavi = new SpNavi(param);

let spnav_accordion_1 = (scroller)=>{
	$('#spnavi .gnavi > ul > li.hasChild >  a + span').off();
	$('#spnavi .gnavi > ul > li.hasChild >  a + span').on('click',function(){
		let $parent = $(this).parent('li');
		let $child = $(this).next('ul');
		let status = $child.css('display');
		if(status == 'block'){
			$child.slideUp(300,function(){
				scroller.refresh();
			});
			$parent.removeClass('active');
		}else{
			$child.slideDown(300,function(){
				scroller.refresh();
			});
			$parent.addClass('active');
		}

		return false;
	});
}

let spnav_accordion_2 = (scroller)=>{
	$('#spnavi .gnavi > ul > li > ul > li.hasChild > a + span').off();
	$('#spnavi .gnavi > ul > li > ul > li.hasChild > a + span').on('click',function(){
		let $parent = $(this).parent('li');
		let $child = $(this).next('ul');
		let status = $child.css('display');

		if(status == 'block'){
			$child.slideUp(300,function(){
				scroller.refresh();
			});
			$parent.removeClass('active');
		}else{
			$child.slideDown(300,function(){
				scroller.refresh();
			});
			$parent.addClass('active');
		}

		return false;
	});
}

spnavi.exec(spnav_accordion_1,spnav_accordion_2);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();

/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
const ac = new Accordion($('.js-accordion .js-accordion-title'));
ac.exec();
const ac_legacy = new Accordion($('.js-accordion .accordion-title'));
ac_legacy.exec();
/* gnavi
----------------------- */
(function($) {
$(function(){
	let fadespeed = 400;
	$('.main_header .gnavi li , .main_header .status').on('mouseenter',function(){
		$(this).find('.js--childnav').stop(true, true).fadeIn(fadespeed);
	}).on('mouseleave',function(){
		$(this).find('.js--childnav').stop(true, true).fadeOut(fadespeed);
	});

	$('.spnavi li.status .btn_close').on('click',function(){
		$(this).parent('.js--childnav').stop(true, true).fadeOut(fadespeed);
		$('.status .point').fadeOut(fadespeed);
	});

	let filter = $('.js--childnav-filter');
	$('.main_header .search').on('click',function(){
		let $child = $(this).next('.js--childnav');
		if($child.css('display') == 'block'){
			$child.fadeOut(fadespeed);
			$(this).removeClass('active');
			filter.hide();
		}else{
			$child.fadeIn(fadespeed);
			$(this).addClass('active');
			filter.show();
		}

		return false;
	});

	filter.on('click',function(){
		$('.main_header .search').click();
	});

	$('.spnavi .status > a').on('click',function(){
		let $child = $(this).next('.js--childnav');
		let $point = $(this).find('.point');

		if($child.css('display') == 'block'){
			$child.fadeOut(fadespeed);
			$point.fadeOut(fadespeed);
			$(this).removeClass('active');
		}else{
			$child.fadeIn(fadespeed);
			$point.fadeIn(fadespeed);
			$(this).addClass('active');
		}

		return false;
	});

	$(window).on('scroll', function(){
		if($(this).width() < 960){
			$('.fixed.main_header').css("left", - $(this).scrollLeft());
		}else{
			$('.fixed.main_header').css("left",0);
		}
	});
});
})(jQuery);

(function($) {
$(function(){
	$('.js-fade_btn').on('mouseenter',function(){
		$(this).find('> span , > input').stop().animate({'opacity':1},400,'swing');
	}).on('mouseleave',function(){
		$(this).find('> span , > input').stop().animate({'opacity':0},400,'swing');
	});

	$('.js-reverse_btn').on('mouseenter',function(){
		$(this).addClass('hover');
	}).on('mouseleave',function(){
		$(this).removeClass('hover');
	});

	$('.aside_footer ul li').on('mouseenter',function(){
		$(this).find('> a > span > span').stop().animate({'opacity':1},400,'swing');
	}).on('mouseleave',function(){
		$(this).find('> a > span > span').stop().animate({'opacity':0},400,'swing');
	});

});
})(jQuery);


(function($) {
$(function(){
	$('a:not(:has(img))').each(function(){
		if($(this).parents('.no_linkicon').length == 0){
			$(this).addClass('js--link_icon');
		}
	});

	//Pdf
	$('.js--link_icon[href$=pdf]').each(function(){
		$(this).addClass('js--link_icon-pdf').attr({target:"_blank"});
		// let url = $(this).attr('href'); //取得 URL
		// let reg = new RegExp("^(https?:)?\/\/"+document.domain);

		// if (url.match(reg) || url.charAt(0) === "/") {
		// 	$(this).addClass('js--link_icon-pdf').attr({target:"_blank"});
		// }else{
		// 	$(this).addClass('js--link_icon-ext').attr({target:"_blank"})
		// }
	});
	//Excel
	$('.js--link_icon[href$=xls],.js--link_icon[href$=xlsx],.js--link_icon[href$=xlsm]').addClass('js--link_icon-xls').attr({target:"_blank"});
	//Word
	$('.js--link_icon[href$=doc],.js--link_icon[href$=docx]').addClass('js--link_icon-docx').attr({target:"_blank"});
	//PowerPoint
	$('.js--link_icon[href$=pptx],.js--link_icon[href$=pptm],.js--link_icon[href$=ppt]').addClass('js--link_icon-pptx').attr({target:"_blank"});
	//外部リンク
	$('.js--link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').addClass('js--link_icon-ext').attr({target:"_blank"});
	$('[href^=http]:not([href*="'+location.hostname+'"]').attr({target:"_blank"});

	$('.js--btn_link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').attr({target:"_blank"});

	$('.page_content-common-component table').each(function(){
		let col_num = [];
		$(this).find('tr').each(function(){
			col_num.push($(this).find('> *').length);
		});

		if(_.max(col_num) > 2){
			$(this).wrap('<div class="component-table_wrap"></div>');
		}

		if(_.max(col_num) == 2){
			$(this).addClass('sp_table_100per');
		}
	})
});
})(jQuery);

(function($) {
$(function(){
	$('.rp').each(function(){
		$(this).wrap('<div class="table-rp"></div>');
	});
});
})(jQuery);



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js